import { render, staticRenderFns } from "./BaseCreate.vue?vue&type=template&id=193d54cb"
import script from "./BaseCreate.vue?vue&type=script&lang=js"
export * from "./BaseCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports